import * as React from 'react';

export function withIcon<P extends object>(icon: React.ReactNode) {

  return (WrappedComponent: React.ComponentClass<P> | React.FC<React.PropsWithChildren<P>>) => {
    return (props: P) => <WrappedComponent {...props} icon={icon} />;
  };
}
